/**
 * @generated SignedSource<<bae8f2400ebe95e113867e20cde18373>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GetExistingOrNewProfileFromKhorosUserIdMutation$variables = {
  khorosUserId: string;
};
export type GetExistingOrNewProfileFromKhorosUserIdMutation$data = {
  readonly unified: {
    readonly profile: {
      readonly getExistingOrNewProfileFromKhorosUserId: {
        readonly errors: ReadonlyArray<{
          readonly code: string | null;
          readonly extensions: {
            readonly errorType: string | null;
            readonly statusCode: number | null;
          } | null;
          readonly message: string | null;
        }> | null;
        readonly success: boolean;
        readonly unifiedProfile: {
          readonly aaid: string | null;
          readonly accountInternalId: string | null;
          readonly id: string;
          readonly internalId: string | null;
          readonly username: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};
export type GetExistingOrNewProfileFromKhorosUserIdMutation = {
  response: GetExistingOrNewProfileFromKhorosUserIdMutation$data;
  variables: GetExistingOrNewProfileFromKhorosUserIdMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "khorosUserId"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UnifiedMutation",
    "kind": "LinkedField",
    "name": "unified",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedProfileMutation",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "khorosUserId",
                "variableName": "khorosUserId"
              }
            ],
            "concreteType": "UnifiedProfilePayload",
            "kind": "LinkedField",
            "name": "getExistingOrNewProfileFromKhorosUserId",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedMutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedMutationErrorExtension",
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "errorType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "statusCode",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "message",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "success",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedProfile",
                "kind": "LinkedField",
                "name": "unifiedProfile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accountInternalId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "aaid",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "internalId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "username",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GetExistingOrNewProfileFromKhorosUserIdMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GetExistingOrNewProfileFromKhorosUserIdMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e86c7af3ce7bdb900348d3ec73235fe5",
    "id": null,
    "metadata": {},
    "name": "GetExistingOrNewProfileFromKhorosUserIdMutation",
    "operationKind": "mutation",
    "text": "mutation GetExistingOrNewProfileFromKhorosUserIdMutation(\n  $khorosUserId: String!\n) {\n  unified {\n    profile {\n      getExistingOrNewProfileFromKhorosUserId(khorosUserId: $khorosUserId) {\n        errors {\n          code\n          extensions {\n            errorType\n            statusCode\n          }\n          message\n        }\n        success\n        unifiedProfile {\n          accountInternalId\n          aaid\n          id\n          internalId\n          username\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e8449a80b6c5e9758301e9d45e4d0c6d";

export default node;
